module.exports = __webpack_public_path__ + "img/markerMagenta.a8869c7a.svg";